import React, { useEffect, useState } from "react";

export default function AuthGuard({ children }) {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    fetch("https://api.theviewage.site/auth/me", {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        if (!data.authenticated) {
          window.location.href = "https://api.theviewage.site/auth/login";
        } else {
          setChecked(true);
        }
      });
  }, []);

  if (!checked) {
    return null;
  }

  return children;
}
